import { render, staticRenderFns } from "./RowWrapper.vue?vue&type=template&id=255d5456&scoped=true&lang=pug&"
import script from "./RowWrapper.vue?vue&type=script&lang=js&"
export * from "./RowWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RowWrapper.vue?vue&type=style&index=0&id=255d5456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d5456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VHover,VIcon})
